import React from 'react';
import ReactDOM from 'react-dom/client';
import { addLocale, locale as setPrimeLocale } from 'primereact/api';
import sr from './locale/sr';
import './index.css';
import './MobileApp.css';
import App from './App';

addLocale('sr', sr);
setPrimeLocale('sr');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
